// The environments a run of this workflow can happen in: what the source step declares, or the
// company default when it declares nothing. An id with no matching environment row is still shown,
// named by its id — dropping it would hide a mapping pointing at a deleted environment.
//
// The source step is always a root step, so the root list is enough to find it.
const resolveWorkflowRunEnvironments = ({ steps, environments }) => {
  const sourceStep = (Array.isArray(steps) ? steps : []).find((step) => ['schedule', 'trigger', 'webhook'].includes(String(step?.type || '').trim()));
  const declared = Array.isArray(sourceStep?.environments) ? sourceStep.environments.map((value) => String(value || '').trim()).filter(Boolean) : [];
  const ids = declared.length > 0 ? [...new Set(declared)] : environments.filter((environment) => environment?.isDefault === true).map((environment) => environment.id);

  return ids.map((id) => ({ id, name: environments.find((environment) => environment?.id === id)?.name || id }));
};

export default resolveWorkflowRunEnvironments;
